import React from "react";

function BusBooking() {
  return <div>BusBooking</div>;
}

export default BusBooking;
